import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";
import { BaseService, ServiceResponse } from "./base.service";

@Injectable({
    providedIn: 'root'
})
export class HomeService extends BaseService {

    override url = `${ environment.host }/home`;

    async comercios( filtros: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${ this.url }/comercios`
            const resp = await lastValueFrom( this.http.post<any>(url, filtros, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async servicios( filtros: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${ this.url }/servicios`
            const resp = await lastValueFrom( this.http.post<any>(url, filtros, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async ultimasAcreditaciones( filtros: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${ this.url }/ultimas-acreditaciones`
            const resp = await lastValueFrom( this.http.post<any>(url, filtros, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);
            
            return this.checkError( error );
        }
    }

    async consumoLimite( filtros: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${ this.url }/consumo-limite`
            const resp = await lastValueFrom( this.http.post<any>(url, filtros, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);
            
            return this.checkError( error );
        }
    }

    async infoTarjetas( filtros: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${ this.url }/info-tarjetas`
            const resp = await lastValueFrom( this.http.post<any>(url, filtros, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);
            
            return this.checkError( error );
        }
    }
    async getMontoCobro( filtros: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const url = `${ this.url }/monto-cobro`
            const resp = await lastValueFrom( this.http.post<any>(url, filtros, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);
            
            return this.checkError( error );
        }
    }
    
}